// ------------------------------------------------------------------------------------------------
import dateFormat from 'dateformat';
import * as  moment from 'moment';
import { isDefined } from './Micro';
// ------------------------------------------------------------------------------------------------
export enum TimeFormat {
    short = 'h:MM TT',
    long = 'h:MM:ss TT',
    longMs = 'h:MM:ss.l TT'
}
// ------------------------------------------------------------------------------------------------
export enum DateFormat {
    Short = 0,
    Long = 1,
    ISO = 2,
    ISOMS = 3
}
// ------------------------------------------------------------------------------------------------
export namespace Formatters {
    // --------------------------------------------------------------------------------------------
    export function datetime(value: any, format: DateFormat, timeEnable: boolean = true): string {
        try {
            if (!isDefined(value))
                return null;

            switch (format) {
                case DateFormat.Long:
                    if (timeEnable)
                        return dateFormat(value, "longDate") + " " + dateFormat(value, "longTime");
                    else
                        return dateFormat(value, "longDate");
                case DateFormat.ISO:
                    if (timeEnable)
                        return dateFormat(value, "isoDate") + " " + dateFormat(value, "isoTime");
                    else
                        return dateFormat(value, "isoDate");
                case DateFormat.ISOMS:
                    if (timeEnable)
                        return dateFormat(value, "isoDate") + " " + dateFormat(value, 'h:MM:ss.l');
                    else
                        return dateFormat(value, "isoDate");
                case DateFormat.Short:
                default:
                    if (timeEnable)
                        return dateFormat(value, "shortDate") + " " + dateFormat(value, "shortTime");
                    else
                        return dateFormat(value, "shortDate");
            }
        }
        catch {
            // Force string return
            return "" + value;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function datetimeRange(startDate, endDate, format: DateFormat, timeEnable: boolean, utc: boolean = undefined): string {
        try {
            if (!isDefined(startDate) || !isDefined(endDate))
                return null;

            switch (format) {
                case DateFormat.Long:
                    if (timeEnable)
                        return dateFormat(startDate, "longDate", utc) + " " + dateFormat(startDate, "longTime", utc)
                            + " - " + dateFormat(endDate, "longDate", utc) + " " + dateFormat(endDate, "longTime", utc);
                    else
                        return dateFormat(startDate, "longDate", utc) + " - " + dateFormat(endDate, "longDate");
                case DateFormat.ISO:
                    if (timeEnable)
                        return dateFormat(startDate, "isoDate", utc) + " " + dateFormat(startDate, "isoTime", utc)
                            + " - " + dateFormat(endDate, "isoDate", utc) + " " + dateFormat(endDate, "isoTime", utc);
                    else
                        return dateFormat(startDate, "isoDate", utc) + " - " + dateFormat(endDate, "isoDate", utc);
                case DateFormat.ISOMS:
                    if (timeEnable)
                        return dateFormat(startDate, "isoDate", utc) + " " + dateFormat(startDate, 'h:MM:ss.l', utc)
                            + " - " + dateFormat(endDate, "isoDate", utc) + " " + dateFormat(endDate, 'h:MM:ss.l', utc);
                    else
                        return dateFormat(startDate, "isoDate", utc) + " - " + dateFormat(endDate, "isoDate", utc);
                case DateFormat.Short:
                default:
                    if (timeEnable)
                        return dateFormat(startDate, "shortDate", utc) + " " + dateFormat(startDate, "shortTime", utc)
                            + " - " + dateFormat(endDate, "shortDate", utc) + " " + dateFormat(endDate, "shortTime", utc);
                    else
                        return dateFormat(startDate, "shortDate", utc) + " - " + dateFormat(endDate, "shortDate", utc);
            }
        }
        catch {
            return startDate + " - " + endDate;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function timeRange(startDate, endDate, format: TimeFormat): string {
        try {
            if (!isDefined(startDate) || !isDefined(endDate))
                return null;

            return time(startDate, format) + " - " + time(endDate, format);
        }
        catch {
            return startDate + " - " + endDate;
        }
    }
    // --------------------------------------------------------------------------------------------
    export function time(value: any, format: TimeFormat): string {
        try {
            if (!isDefined(value))
                return "";

            // Compute incoming value to time based on format.
            return dateFormat(
                moment(value, format == TimeFormat.longMs ? 'HH:mm:ss.SSS' : 'HH:mm:ss').toDate(),
                format
            );
        } catch {
            // Force string return
            return "" + value;
        }
    }
    // --------------------------------------------------------------------------------------------
}
// ------------------------------------------------------------------------------------------------